import { useEffect } from 'react';

type SeoProps = {
  title: string;
  description: string;
  canonicalPath: string;
};

const siteUrl = 'https://balirentalfinder.com';

function setMeta(name: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.name = name;
    document.head.appendChild(element);
  }
  element.content = content;
}

function setCanonical(href: string) {
  let element = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.rel = 'canonical';
    document.head.appendChild(element);
  }
  element.href = href;
}

export function Seo({ title, description, canonicalPath }: SeoProps) {
  useEffect(() => {
    const previousTitle = document.title;
    const previousDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]')?.content;
    const previousCanonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.href;

    document.title = title;
    setMeta('description', description);
    setCanonical(`${siteUrl}${canonicalPath}`);

    return () => {
      document.title = previousTitle;
      if (previousDescription) {
        setMeta('description', previousDescription);
      }
      const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (previousCanonical) {
        setCanonical(previousCanonical);
      } else {
        canonical?.remove();
      }
    };
  }, [canonicalPath, description, title]);

  return null;
}
